__turbopack_context__.v({
  "bar": "FundraiserProgressBar-module-scss-module__0MjIgG__bar",
  "barcontainer": "FundraiserProgressBar-module-scss-module__0MjIgG__barcontainer",
  "container": "FundraiserProgressBar-module-scss-module__0MjIgG__container",
  "text": "FundraiserProgressBar-module-scss-module__0MjIgG__text",
});
